const $ = jQuery.noConflict();

'use strict';
const GravityForm = {

	init: function() {
		$('input').on('focus', function() {
			$(this).parent().addClass('field-focused');
		});

		$('input').on('blur', function() {
			$(this).parent().removeClass('field-focused');
		});

		$('textarea').on('focus', function() {
			$(this).parent().addClass('field-focused');
		});

		$('textarea').on('blur', function() {
			$(this).parent().removeClass('field-focused');
		});

		$('select').on('focus', function() {
			$(this).parent().parent().addClass('field-focused');
		});

		$('select').on('blur', function() {
			$(this).parent().parent().removeClass('field-focused');
		});

		// date
		$('.ginput_container_date input').on('keydown', function(e) {
			e.preventDefault();
			return false;
		});

		const numberInput = $('.ginput_container_phone input');

		$(function() {
			numberInput.keypress(function(e) {
				if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
					return false;
				}
			});
		});
	},
};

export default GravityForm;
